import React from 'react';
import { IconProps } from './IconTypes';

const PublicLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="50" cy="28" r="14" />
      <path d="M22,82 C22,64 35,54 50,54 C65,54 78,64 78,82 L78,90 L22,90 Z" />
      <circle cx="20" cy="38" r="11" />
      <path d="M2,82 C2,68 11,60 22,60 C24,60 26,60.3 28,61 C24,67 22,74 22,82 L22,90 L2,90 Z" />
      <circle cx="80" cy="38" r="11" />
      <path d="M98,82 C98,68 89,60 78,60 C76,60 74,60.3 72,61 C76,67 78,74 78,82 L78,90 L98,90 Z" />
    </svg>
  );
};

export default PublicLogo;
